import { render, staticRenderFns } from "./DetailsOpportunity.vue?vue&type=template&id=2b53706c&scoped=true&"
import script from "./DetailsOpportunity.vue?vue&type=script&lang=js&"
export * from "./DetailsOpportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53706c",
  null
  
)

export default component.exports